import { getCurrentWindowMode } from '../../utils-window/get-current-window-mode';

/**
 * Get current breakpoint name for animation processing.
 * Uses the proper breakpoint detection system when available.
 *
 * @since ??
 *
 * @returns {string} Current breakpoint name: 'desktop', 'tablet', 'phone', etc.
 */
export const getCurrentAnimationBreakpoint = (): string => {
  // First try to use the global animation breakpoint if available.
  if ('string' === typeof window.et_animation_breakpoint && window.et_animation_breakpoint) {
    return window.et_animation_breakpoint;
  }

  // Get current breakpoint name ('desktop', 'tablet', 'phone', etc.) using the customizable breakpoint system.
  // This ensures animation properties like duration_tablet and delay_phone are used on the correct devices.
  return getCurrentWindowMode();
};
